<swal #currentSwal title="Operación" text="Operación realizada" icon="info"></swal>
<swal #notesSwal title="Operación" text="Operación realizada" icon="info"></swal>

<!-- <h1>{{fileIdValue ? fileIdValue: 'Sin id por ruta'}}</h1> -->
<ngx-loading [show]="loading" [config]="{ backdropBorderRadius: '3px' }" [template]="customLoadingTemplate"> </ngx-loading>
<ng-template #customLoadingTemplate></ng-template>
<div class="app-content content">
	<div class="content-wrapper">
		<div class="content-header row mb-1"></div>
		<div class="content-detached">
			<div class="content-body" *ngIf="!withOutAccess; else withOutAccessForm">
				<!-- insertar barra de busqueda -->
				<app-search-bar
					[criterioPrincipal]="configLocal.barraBusqueda.criterioPrincipal"
					[config]="configLocal.barraBusqueda"
					[filtroDTE]="true"
					[filtroAnulados]="true"
					[filtroTieneNC]="true"
					[filtroEmisor]="false"
					[filtroEstadoDte]="false"
					[filtroCedida]="true"
					[filtroEstadoDteRecibido]="true"
					[filtroRespuestaEstadoDte]="true"
					[nombreCampoDatePicker]="configLocal.barraBusqueda.nombreCampoDatePicker"
					[listaCompletaEmisores]="emisorSource"
					[useAccordionMode]="true"
					[extraLengthGenericInput]="true"
					(busqueda)="searchElementsByFilter($event)"
				></app-search-bar>
				<section class="row">
					<div class="col-12">
						<div class="card card-custom">
							<div class="card-header">
								<h4 class="card-title" *ngIf="casillaCorreoDteRecibido.correo == null">{{ configLocal.table.title }}</h4>
								<h4 class="card-title" *ngIf="casillaCorreoDteRecibido.correo != null">{{ configLocal.table.title }} desde {{ casillaCorreoDteRecibido.correo }}</h4>
								<div class="card-toolbar">
									<!-- insertar botonera -->
									<!-- <button class="btn btn-success" (click)="openAddDteFileModal(loadFileModal)">
                                        <i class="flaticon-upload"></i>
                                        <span>{{configLocal.table.add}}</span> 
                                    </button> -->
								</div>
							</div>
							<div class="card-head">
								<div class="heading-elements mt-0">
									<div ngbDropdown class="btn-Acuse">
										<button ngbDropdownToggle id="dropdownAcuse" class="btn btn-success float-right mr-5 mt-5">
											<fa-icon icon="check-square" class="fa-lg text-white"></fa-icon>
											Acuse
										</button>
										<div ngbDropdownMenu aria-labelledby="dropdownAcuse">
											<button *ngIf="permissions.getPermission('50-10-08').asignado" data-gtm-id="aceptar" data-gtm-group="recibidos" class="buttonMantenedor" ngbDropdownItem (click)="openAcuseMasivoModal(acuseMasivo, true)">Aceptar</button>
											<button *ngIf="permissions.getPermission('50-10-09').asignado" data-gtm-id="rechazar" data-gtm-group="recibidos" class="buttonMantenedor" ngbDropdownItem (click)="openAcuseMasivoModal(acuseMasivo, false)">Rechazar</button>
										</div>
									</div>
									<button class="buttonMantenedor btn btn-warning float-right mr-5 mt-5 btn-export" data-gtm-id="exportar" data-gtm-group="recibidos" (click)="openExportModal()" ngbTooltip="Exporta tus registros a Excel" *ngIf="permissions.getPermission('50-10-16').asignado">
										<i class="flaticon-download-1"></i>
										Exportar
									</button>

									<div ngbDropdown class="btn-Descargar-documentos">
										<button ngbDropdownToggle id="dropdownDescargas" class="btn btn-primary float-right mr-5 mt-5" *ngIf="permissions.getPermission('50-10-14').asignado">
											<i class="flaticon-mail-1"></i>
											Descarga Documentos
										</button>
										<div ngbDropdownMenu aria-labelledby="dropdownDescargas">
											<button class="buttonMantenedor" data-gtm-id="descarga-pdf" data-gtm-group="recibidos" ngbDropdownItem (click)="multipleDocumentDownload('pdf')">Descarga PDF</button>
											<button class="buttonMantenedor" data-gtm-id="descarga-xml" data-gtm-group="recibidos" ngbDropdownItem (click)="multipleDocumentDownload('xml')">Descarga XML</button>
										</div>
									</div>

									<div ngbDropdown>
	
										<button ngbDropdownToggle ngbTooltip="Si necesitas traer DTEs que estén en el SII y no aquí" id="dropdownConciliacion" class="btn btn-info float-right mr-5 mt-5">
											<i class="flaticon-refresh"></i>
											Importar desde el SII
										</button>
										<div ngbDropdownMenu aria-labelledby="dropdownDescargas">
											<button class="buttonMantenedor" data-gtm-id="importacion-mes" data-gtm-group="recibidos" ngbDropdownItem (click)="openDatePickerConciliacion(datePickerConciliacionModal, true)">Importación por Mes</button>
											<button class="buttonMantenedor" data-gtm-id="importacion-dia" data-gtm-group="recibidos"  ngbDropdownItem (click)="openDatePickerConciliacion(datePickerConciliacionModal, false)">Importación por Día</button>
										</div>
									</div>
								</div>
							</div>
							<div class="card-content">
								<div class="card-body">
									<!-- inicion seccion botones agregar y exportar -->
									<!-- <app-exportacion-datos [dataArray]="rowsMantenedor" [exportCriteria]="criteriosEnBase"></app-exportacion-datos> -->

									<!-- fin seccion botones -->

									<!-- seccion tabla -->
									<ngx-datatable
										#table
										*ngIf="componentStarted"
										class="material mobile-hidden"
										[rows]="rowsMantenedor"
										[columnMode]="'flex'"
										[headerHeight]="50"
										[footerHeight]="50"
										[rowHeight]="80"
										fxFlex="auto"
										[perfectScrollbar]="configScroll"
										[selectionType]="'checkbox'"
										[selected]="selected"
										(selected)="onSelect($event)"
										[rowIdentity]="getId"
										[externalPaging]="true"
										[count]="page.totalElements"
										[offset]="page.pageNumber"
										[limit]="page.pageSize"
										(page)="setPage($event)"
										(sort)="utilities.onSortTable(table, page)"
										[messages]="{ emptyMessage: 'Sin datos para mostrar' | translate, totalMessage: 'Elementos totales' | translate, selectedMessage: false }"
										[externalSorting]="false"
										[sortType]="SortType.multi"
									>
										<ngx-datatable-column [width]="40" [sortable]="false" [canAutoResize]="false" [draggable]="false" [resizeable]="false">
											<ng-template ngx-datatable-header-template let-value="value">
												<input type="checkbox" class="customCheckbox" [checked]="selectedAllItemsInPage[page.pageNumber]" (change)="selectAll($event)" />
											</ng-template>
											<ng-template ngx-datatable-cell-template let-value="value" let-isSelected="isSelected" let-onCheckboxChangeFn="onCheckboxChangeFn">
												<input type="checkbox" class="customCheckbox" [checked]="isSelected" (change)="onCheckboxChangeFn($event)" />
											</ng-template>
										</ngx-datatable-column>
										<ngx-datatable-column name="folio" [flexGrow]="2.5" [sortable]="true" [resizeable]="false" [cellClass]="'number-table-alignment'" [headerClass]="'number-table-alignment'">
											<ng-template let-column="column" ngx-datatable-header-template>
												<span class="text-table-alignment">Documento</span>
											</ng-template>
											<ng-template ngx-datatable-cell-template let-row="row"
												><span class="text-table-alignment text-wrap">{{ row.nombreTipoDte }}: {{ row.folio }}</span>
											</ng-template>
										</ngx-datatable-column>
										<ngx-datatable-column name="fechaEmision" [flexGrow]="2" [sortable]="true" [resizeable]="false" [cellClass]="'date-table-alignment'" [headerClass]="'date-table-alignment'">
											<ng-template let-column="column" ngx-datatable-header-template>
												<span class="text-table-alignment">Emision</span>
											</ng-template>
											<ng-template ngx-datatable-cell-template let-row="row"
												><span class="text-table-alignment">{{ row.fechaEmision | date : "dd/MM/yyyy" }}</span>
											</ng-template>
										</ngx-datatable-column>
										<ngx-datatable-column name="fechaVencimientoAcuse" [flexGrow]="2" [sortable]="true" [resizeable]="false" [cellClass]="'date-table-alignment'" [headerClass]="'date-table-alignment'">
											<ng-template let-column="column" ngx-datatable-header-template>
												<span class="text-table-alignment">Venc Acuse</span>
											</ng-template>
											<ng-template ngx-datatable-cell-template let-row="row"
												><span class="text-table-alignment">{{ row.fechaVencimientoAcuse | date : "dd/MM/yyyy" }}</span></ng-template
											>
										</ngx-datatable-column>
										<ngx-datatable-column name="Proveedor" [flexGrow]="4.5" [sortable]="false" [resizeable]="false" [cellClass]="'text-table-alignment'" [headerClass]="'text-table-alignment'">
											<ng-template let-column="column" ngx-datatable-header-template>
												<span class="text-table-alignment">Proveedor</span>
											</ng-template>
											<ng-template ngx-datatable-cell-template let-row="row"
												><span class="text-table-alignment text-wrap">{{ row.razonSocialProveedor }}</span>
											</ng-template>
										</ngx-datatable-column>
										<ngx-datatable-column name="total" [flexGrow]="2.5" [sortable]="true" [cellClass]="getCellClass" [resizeable]="false" [headerClass]="'number-table-alignment'">
											<ng-template let-column="column" ngx-datatable-header-template>
												<span class="number-table-alignment">Total</span>
											</ng-template>
											<ng-template ngx-datatable-cell-template let-row="row"
												><span class="number-table-alignment">{{
													row.total
														| currency
															: "$
                                       "
															: "symbol"
															: "1.0-0"
															: "es"
												}}</span></ng-template
											>
										</ngx-datatable-column>
										<ngx-datatable-column [cellTemplate]="semaforo" [sortable]="false" name="Estado" [flexGrow]="2" [resizeable]="false"></ngx-datatable-column>
										<ngx-datatable-column name="Acciones" [flexGrow]="4.5" [sortable]="false" [resizeable]="false">
											<ng-template ngx-datatable-cell-template let-row="row">
												<a [routerLink]="" ngbTooltip="Ver Detalles" class="primary edit mr-1 mrless" id="documentos-recibidos.component_Ver_Detalles" (click)="DetailDteModal(dteDetailModal, row)" *ngIf="permissions.getPermission('50-10-18').asignado">
													<div class="icon-circle bg-warning text-center align-middle pt-info-button">
														<fa-icon icon="info-circle" class="fa-lg text-white"></fa-icon>
													</div>
												</a>
												<a [routerLink]="" ngbTooltip="Trazabilidad" class="primary edit mr-1 mrless" id="documentos-recibidos.component_Trazabilidad" (click)="openTraceShowModal(dteTracesModal, row)" *ngIf="permissions.getPermission('50-10-20').asignado">
													<div class="icon-circle bg-info text-center align-middle pt-list-button">
														<fa-icon icon="list-alt" class="fa-lg text-white"></fa-icon>
													</div>
												</a>
												<div ngbDropdown class="dropdownBotoneraLinea" container="body">
													<a [routerLink]="" title="Descarga Documento" ngbTooltip="Descarga Documento" class="success edit mr-1 mrless" ngbDropdownToggle id="dropdownDoc" container="body" *ngIf="permissions.getPermission('40-18-22').asignado && row.conArchivo">
														<div class="icon-circle bg-danger text-center align-middle pt-file-button">
															<fa-icon icon="file-pdf" class="fa-lg text-white"></fa-icon>
														</div>
													</a>

													<div ngbDropdownMenu aria-labelledby="dropdownDoc">
														<button ngbDropdownItem (click)="downloadPDF(row)" *ngIf="permissions.getPermission('50-10-22').asignado">Descarga PDF</button>
														<button ngbDropdownItem (click)="downloadPDFCedible(row)" *ngIf="permissions.getPermission('50-10-23').asignado">Descarga PDF Cedible</button>
														<button ngbDropdownItem (click)="downloadXml(row)" *ngIf="permissions.getPermission('50-10-24').asignado">Descargar XML</button>
													</div>
												</div>
												<a
													*ngIf="row.acuseHabilitado && row.codigoTipoDte != 52 && permissions.getPermission('50-10-26').asignado && getThirdDotClass(row)"
													[routerLink]=""
													ngbTooltip="Acuse de Recibo"
													class="edit mr-1 mrless"
													[ngClass]="{
														success: row.estado == 3,
														danger: row.estado == 2
													}"
													(click)="statusDocModal(statusDocForm, row)"
												>
													<div
														class="icon-circle bg-success text-center align-middle pt-file-button"
														[ngClass]="{
															'bg-success': row.estado == 3 || row.estado == 2
														}"
													>
														<!-- estado = 3, recibido conforme. estado = 2, recibido solo en SII -->
														<fa-icon icon="bookmark" class="fa-lg text-white"></fa-icon>
													</div>
												</a>
												<span class="badge badge-danger imported-badge font-italic" *ngIf="row.nula">Nula</span>
												<span class="badge badge-danger imported-badge font-italic" *ngIf="row.cedida">Cedida</span>
												<span class="badge badge-light imported-badge font-italic" *ngIf="row.tieneNC && !row.nula">Tiene NC</span>
												<span class="badge badge-primary imported-badge font-italic" *ngIf="row.tieneTipoAcuse">Tipo Acuse</span>
											</ng-template>
										</ngx-datatable-column>
										<ngx-datatable-footer>
											<ng-template ngx-datatable-footer-template let-rowCount="rowCount" let-pageSize="pageSize" let-selectedCount="selectedCount" let-curPage="curPage" let-offset="offset" let-isVisible="isVisible">
												<div class="col-auto">Elementos por página</div>
												<div class="mr-5">
													<ng-select [(ngModel)]="page.pageSize" [items]="page.pageSizes" [clearable]="false" (change)="setPageSize()" dropdownPosition="top" style="overflow: visible" appendTo="datatable-footer">
														<option *ngFor="let option of page.pageSizes" [value]="option"></option>
													</ng-select>
												</div>
												<div class="ml-5 col-auto divisor-footer">
													<div class="page-count">{{ rowCount }} Elementos totales</div>
												</div>
												<datatable-pager [pagerLeftArrowIcon]="'datatable-icon-left'" [pagerRightArrowIcon]="'datatable-icon-right'" [pagerPreviousIcon]="'datatable-icon-prev'" [pagerNextIcon]="'datatable-icon-skip'" [page]="curPage" [size]="pageSize" [count]="rowCount" [hidden]="!(rowCount / pageSize > 1)" (change)="table.onFooterPage($event)"> </datatable-pager>
											</ng-template>
										</ngx-datatable-footer>
									</ngx-datatable>

									<!-- tabla movil-->
									<ngx-datatable
										#tableMobile
										class="material desktop-hidden"
										[rows]="rowsMantenedor"
										[columnMode]="'flex'"
										[headerHeight]="50"
										[footerHeight]="70"
										[rowHeight]="70"
										fxFlex="auto"
										[perfectScrollbar]="configScroll"
										[selectionType]="'checkbox'"
										*ngIf="componentStarted && rowsMantenedor.length > 0"
										[selected]="selected"
										(selected)="onSelect($event)"
										[rowIdentity]="getId"
										[externalPaging]="true"
										[count]="page.totalElements"
										[offset]="page.pageNumber"
										[limit]="page.pageSize"
										(page)="setPage($event)"
										[messages]="{ emptyMessage: 'Sin datos para mostrar' | translate, totalMessage: 'Elementos totales' | translate, selectedMessage: false }"
									>
										<!-- Row Detail Template -->
										<ngx-datatable-row-detail [rowHeight]="70" #myDetailRow (toggle)="onDetailToggle($event)">
											<ng-template let-row="row" let-expanded="expanded" ngx-datatable-row-detail-template>
                                                                               <div class="text-wrap">Tipo Documento: {{ row.nombreTipoDte }} , Proveedor: {{ row.razonSocialProveedor ? row.razonSocialProveedor : "No disponible" }} , Folio: {{ row.folio }} , Fecha Emisión: {{ row.fechaEmision | date : "dd/MM/yyyy" }} , Fecha Recepción SII: {{ row.fechaRecepcionSii | date : "dd/MM/yyyy" }} , Vencimiento del Acuse: {{ row.fechaVencimientoAcuse | date : "dd/MM/yyyy" }}</div>
                                                                               <div class="text-wrap" *ngIf="row.referencias">Referencias: {{ row.referencias }}</div>
											</ng-template>
										</ngx-datatable-row-detail>
										<ngx-datatable-column [width]="30" [resizeable]="false" [sortable]="false" [draggable]="false" [canAutoResize]="false">
											<ng-template let-row="row" let-expanded="expanded" ngx-datatable-cell-template>
												<a [class.datatable-icon-right]="!expanded" [class.datatable-icon-down]="expanded" title="Expand/Collapse Row" (click)="toggleExpandRow(row)" class="desktop-hidden"> </a>
											</ng-template>
										</ngx-datatable-column>

										<ngx-datatable-column name="folio" [flexGrow]="2.5" [sortable]="true" [resizeable]="false" [cellClass]="'number-table-alignment'" [headerClass]="'number-table-alignment'">
											<ng-template let-column="column" ngx-datatable-header-template>
												<span class="text-table-alignment">Documento</span>
											</ng-template>
											<ng-template ngx-datatable-cell-template let-row="row"
												><span class="text-table-alignment text-wrap">{{ row.nombreTipoDte }}: {{ row.folio }}</span>
											</ng-template>
										</ngx-datatable-column>

										<ngx-datatable-column name="Acciones" [flexGrow]="3" [sortable]="false" [resizeable]="false">
											<ng-template ngx-datatable-cell-template let-row="row">
												<div class="action-container">
													<div class="main-action-button" (click)="toggleActions(row)" *ngIf="!row.showActions">
														<fa-icon [icon]="row.showActions ? 'minus' : 'list'"></fa-icon>
													</div>

													<div class="action-buttons action-buttons-client" [ngClass]="{ show: row.showActions }">
														<a [routerLink]="" ngbTooltip="Ver Detalles" class="primary edit mr-1 mrless" id="documentos-recibidos.component_Ver_Detalles" (click)="DetailDteModal(dteDetailModal, row)" *ngIf="permissions.getPermission('50-10-18').asignado">
															<div class="icon-circle bg-warning text-center align-middle pt-info-button">
																<fa-icon icon="info-circle" class="fa-lg text-white"></fa-icon>
															</div>
														</a>
														<a [routerLink]="" ngbTooltip="Trazabilidad" class="primary edit mr-1 mrless" id="documentos-recibidos.component_Trazabilidad" (click)="openTraceShowModal(dteTracesModal, row)" *ngIf="permissions.getPermission('50-10-20').asignado">
															<div class="icon-circle bg-info text-center align-middle pt-list-button">
																<fa-icon icon="list-alt" class="fa-lg text-white"></fa-icon>
															</div>
														</a>
														<a [routerLink]="" *ngIf="row.estado != 2 && row.estado != 4 && permissions.getPermission('50-10-22').asignado" title="Ver PDF" ngbTooltip="Ver PDF" class="success edit mr-1 mrless" (click)="downloadPDF(row)">
															<div class="icon-circle bg-danger text-center align-middle pt-file-button">
																<fa-icon icon="file-pdf" class="fa-lg text-white"></fa-icon>
															</div>
														</a>
														<a [routerLink]="" *ngIf="row.estado != 2 && row.estado != 4 && permissions.getPermission('50-10-24').asignado" ngbTooltip="Descargar XML" class="success edit mr-1 mrless" (click)="downloadXml(row)">
															<div class="icon-circle bg-warning text-center align-middle pt-file-button">
																<fa-icon icon="file-code" class="fa-lg text-white"></fa-icon>
															</div>
														</a>
														<a *ngIf="row.acuseHabilitado && row.estado == 3 && permissions.getPermission('50-10-26').asignado" [routerLink]="" ngbTooltip="Acuse de Recibo" class="success edit mr-1 mrless" (click)="statusDocModal(statusDocForm, row)">
															<div class="icon-circle bg-success text-center align-middle pt-file-button">
																<fa-icon icon="bookmark" class="fa-lg text-white"></fa-icon>
															</div>
														</a>
													</div>
												</div>
											</ng-template>
										</ngx-datatable-column>
										<ngx-datatable-footer>
											<ng-template ngx-datatable-footer-template let-rowCount="rowCount" let-pageSize="pageSize" let-selectedCount="selectedCount" let-curPage="curPage" let-offset="offset" let-isVisible="isVisible">
												<div class="row" style="width: 100%">
													<div class="col-12 mb-2 ml-3 text-center mt-2">
														<datatable-pager [pagerLeftArrowIcon]="'datatable-icon-left'" [pagerRightArrowIcon]="'datatable-icon-right'" [pagerPreviousIcon]="'datatable-icon-prev'" [pagerNextIcon]="'datatable-icon-skip'" [page]="curPage" [size]="pageSize" [count]="rowCount" [hidden]="!(rowCount / pageSize > 1)" (change)="tableMobile.onFooterPage($event)"> </datatable-pager>
													</div>
													<div class="col-12 d-flex justify-content-center">
														<span class="mr-2 mt-3">Elementos por página</span>

														<ng-select [(ngModel)]="page.pageSize" [items]="page.pageSizes" [clearable]="false" (change)="setPageSize()" dropdownPosition="top" style="overflow: visible" appendTo="body">
															<option *ngFor="let option of page.pageSizes" [value]="option"></option>
														</ng-select>
														<span class="ml-4 mt-3"> Página {{ curPage }} de {{ getTotalPages(rowCount, pageSize) }} </span>
													</div>
												</div>
											</ng-template>
										</ngx-datatable-footer>
									</ngx-datatable>
								</div>
							</div>
						</div>
					</div>
				</section>
			</div>
		</div>
	</div>
</div>

<ng-template #withOutAccessForm>
	<div class="content-body">
		<div class="row">
			<div class="col-8 offset-2">
				<div class="card card-custom">
					<div class="card-body">
						<h1 class="text-danger">Acceso no autorizado</h1>

						<p>El módulo de DTEs Recibidos se encuentra incorporado en todos los planes de SimpleFactura a contar desde el Plan Pyme en adelante. Tu plan es <b>Independiente</b>. Puedes cambiar de plan o agregar este adicional en tu <a href="" [routerLink]="'/plan'">Panel de Usuario</a>. Contacta al área comercial para más información.</p>
						<p>Su cuenta no tiene permisos suficientes para acceder al modulo solicitado. Favor contacte a su administrador.</p>
					</div>
				</div>
			</div>
		</div>
	</div>
</ng-template>

<ng-template #semaforo let-row="row">
	<app-semaforo-estado-recibido [row]="row"></app-semaforo-estado-recibido>
</ng-template>

<ng-template #statusDocForm let-d="dismiss">
	<form (ngSubmit)="statusDoc(statusForm)" #statusForm="ngForm">
		<div class="modal-lg">
			<div class="modal-header">
				<h5 class="modal-title" id="exampleModalLabel1">Acuse de Recibo del Documento {{ dteRejected.nombreTipoDte }} Folio {{ dteRejected.folio }}</h5>
				<button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
					<span aria-hidden="true">&times;</span>
				</button>
			</div>
			<div class="modal-body">
				<!-- <div class="form-group mx-auto">
					<div class="alert alert-success" role="alert" *ngIf="(dteRejected.estadoValidacionId == estadoValidacionDteRecibido['Pre-aprobada'] || dteRejected.estadoValidacionId == estadoValidacionDteRecibido['Aceptada']) && dteRejected.resultadoValidacionAutomatica">
						{{ dteRejected.resultadoValidacionAutomatica }}
					</div>
					<div class="alert alert-primary" role="alert" *ngIf="dteRejected.estadoValidacionId == estadoValidacionDteRecibido['No validada'] && !dteRejected.resultadoValidacionAutomatica">El documento no ha sido validado aún.</div>
					<div class="alert alert-danger" role="alert" *ngIf="(dteRejected.estadoValidacionId == estadoValidacionDteRecibido['Pre-rechazada'] || dteRejected.estadoValidacionId == estadoValidacionDteRecibido['Rechazada']) && dteRejected.resultadoValidacionAutomatica">
						{{ dteRejected.resultadoValidacionAutomatica }}
					</div>
				</div> -->

				<div class="form-group row mx-auto" style="align-items: baseline">
					<label class="col-3 label-control" for="projectinput1">Motivo</label>
					<div class="col-9">
						<ng-select [items]="motivos" [searchable]="false" [clearable]="false" [selectOnTab]="false" [(ngModel)]="motivoAcuse" bindLabel="name" [ngModelOptions]="{ standalone: true }" [disabled]="motivoAcuseDeshabilitado"   (ngModelChange)="onMotivoAcuseChange($event)"
						>
							<ng-template ng-option-tmp let-item="item">
								{{ item.name }}
							</ng-template>
						</ng-select>
					</div>
				</div>
				<div class="form-group row mx-auto" style="align-items: baseline">
					<label class="col-3 label-control" for="projectinput2">Tipo(s) de Acuse a Enviar:</label>
					<div class="col-9">
						<div class="form-check form-check-inline">
							<input
								class="form-check-input"
								type="checkbox"
								id="acuseRevisionDte"
								[(ngModel)]="acuseRevisionDte"
								name="acuseRevisionDte"
								[ngModelOptions]="{ standalone: true }"
							/>
							<label class="form-check-label" for="acuseRevisionDte">
								Revisión de DTE
							</label>
						</div>
						<div class="form-check form-check-inline">
							<input
								class="form-check-input"
								type="checkbox"
								id="acuseReciboMercaderias"
								[(ngModel)]="acuseReciboMercaderias"
								name="acuseReciboMercaderias"
								[ngModelOptions]="{ standalone: true }"
								[disabled]="motivoAcuse === motivos[2]"
							/>
							<label class="form-check-label" for="acuseReciboMercaderias">
								Recibo de Mercaderías
							</label>
						</div>
					</div>
				</div>
				<div *ngIf="motivoAcuse == motivos[2] && permissions.getPermission('50-10-26-14').asignado" class="form-group row mx-auto" style="align-items: baseline">
					<label class="col-3 label-control" for="projectinput1">Motivo</label>
					<div class="col-9">
						<ng-select [items]="AcuseReciboRejectedTypes" [searchable]="false" [clearable]="false" [selectOnTab]="false" [(ngModel)]="tipoRechazoAcuse" bindLabel="nombre" [ngModelOptions]="{ standalone: true }"></ng-select>
					</div>
				</div>

				<div *ngIf="(motivoAcuse == motivos[2] && permissions.getPermission('50-10-26-14').asignado) || (motivoAcuse == motivos[1] && permissions.getPermission('50-10-26-12').asignado)" class="form-group row mx-auto" style="align-items: baseline">
					<label class="col-3 label-control" for="projectinput1">Comentario</label>
					<div class="col-9">
						<textarea
							type="text"
							name="comentario"
							placeholder="Ingrese un comentario"
							class="form-control"
							#comentario="ngModel"
							[(ngModel)]="comentarioAcuse"
							[ngClass]="{
								'is-invalid': !statusForm.submitted && comentario.invalid
							}"
							required
						></textarea>
						<div *ngIf="!statusForm.submitted && comentario.invalid" class="invalid-feedback-group">
							<div *ngIf="comentario.errors.required">Campo obligatorio</div>
						</div>
					</div>
				</div>
			</div>
			<div class="modal-footer">
				<alert id="alert-errormodal"></alert>
				<div class="form-group position-relative has-icon-left mb-0">
					<button [disabled]="statusForm.invalid" type="submit" id="add-contact-item" class="btn btn-info add-contact-item">
						<i class="la la-paper-plane-o d-lg-none"></i>
						<span class="d-none d-lg-block">Guardar</span>
					</button>
				</div>
				<div class="form-group position-relative has-icon-left mb-0">
					<button type="button" class="btn btn-success" data-dismiss="modal" (click)="d('Cross click')">Volver</button>
				</div>
			</div>
		</div>
	</form>
</ng-template>

<ng-template #dteTracesModal let-d="dismiss">
	<div class="modal-content">
		<div class="modal-header">
			<h5 class="modal-title" id="exampleModalLabel1">Trazabilidad</h5>
		</div>
		<form #TrazaForm="ngForm">
			<div class="modal-body">
				<div class="form-group row mx-auto" style="align-items: baseline">
					<label class="col-3 label-control" for="projectinput1">Documento:</label>
					<div class="col-9">
						<input type="text" value="{{ dteToShow.nombreTipoDte }} N° {{ dteToShow.folio }}" disabled name="ngModel" class="form-control" id="fecha" />
					</div>
				</div>
				<div class="form-group row mx-auto" style="align-items: baseline">
					<table class="table table-bordered" [hidden]="tracesToShow.length == 0">
						<thead>
							<tr>
								<th>Fecha</th>
								<th>Descripción</th>
							</tr>
						</thead>
						<tbody>
							<tr *ngFor="let traza of tracesToShow">
								<td>
									{{ traza.fecha | date : "dd/MM/yyyy HH:mm" }}
								</td>
								<td style="overflow-wrap: anywhere">{{ traza.descripcion }}</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
			<div class="modal-footer">
				<button type="button" class="btn btn-success" data-dismiss="modal" (click)="d('Cross click')">Volver</button>
			</div>
		</form>
	</div>
</ng-template>

<ng-template #dteDetailModal let-d="dismiss" id="detail-modal">
	<div class="modal-content">
		<div class="modal-header">
			<div class="modal-wizard-label">
				<div class="modal-wizard-title">Detalle de {{ dteToShow.nombreTipoDte }} - N° {{ dteToShow.folio }}</div>
				<div class="modal-wizard-desc">Detalles del documento seleccionado</div>
			</div>
		</div>
		<div class="modal-body">
			<div class="row form-group mx-auto" id="details-client">
				<h4>Datos del Proveedor</h4>
				<div class="col-12">
					<div class="row">
						<table class="detail-table">
							<tr>
								<td>Rut</td>
								<td>{{ dteToShow.rutProveedorDv ? dteToShow.rutProveedorDv : "No disponible" }}</td>
							</tr>
							<tr>
								<td>Razón Social</td>
								<td>{{ dteToShow.razonSocialProveedor ? dteToShow.razonSocialProveedor : "No disponible" }}</td>
							</tr>
							<tr>
								<td>Giro</td>
								<td>{{ dteToShow.giroProveedor ? dteToShow.giroProveedor : "No disponible" }}</td>
							</tr>
							<tr>
								<td>Comuna</td>
								<td>{{ dteToShow.comunaProvedor ? dteToShow.comunaProvedor : "No disponible" }}</td>
							</tr>
							<tr>
								<td>Ciudad</td>
								<td>{{ dteToShow.ciudadProveedor ? dteToShow.ciudadProveedor : "No disponible" }}</td>
							</tr>
							<tr>
								<td>Dirección</td>
								<td>{{ dteToShow.dirFactProveedor ? dteToShow.dirFactProveedor : "No disponible" }}</td>
							</tr>
							<tr>
								<td>Email</td>
								<td>{{ dteToShow.correoParProveedor ? dteToShow.correoParProveedor : "No disponible" }}</td>
							</tr>
						</table>
						<br />
						<hr />
					</div>
				</div>
			</div>

			<h4>Detalles del Documento</h4>
			<div class="row form-group mx-auto" id="details-client">
				<div class="col-12">
					<div class="row">
						<div class="col-6">
							<span class="d-block">Fecha Emision</span>
							<span class="d-block">Fecha Recepción</span>
							<span class="d-block">Fecha Procesamiento</span>
							<span class="d-block">Fecha Vencimiento de Acuse</span>
							<span class="d-block">Fecha Vencimiento Dte</span>
							<span *ngIf="dteToShow.acuseHabilitado" class="d-block">Dias de Acuse Pendientes</span>
							<span *ngIf="dteToShow.respuestaEstadoId == null" class="d-block">Seguimiento Acuse</span>
							<span *ngIf="dteToShow.respuestaEstadoId != null && dteToShow.respuestaEstadoId != RespuestasEstadoAcuseDte[4].id && dteToShow.motivo != ''" class="d-block">Seguimiento de Acuse</span>
							<span *ngIf="dteToShow.respuestaEstadoId != null && dteToShow.respuestaEstadoId == RespuestasEstadoAcuseDte[4].id && dteToShow.motivo != ''" class="d-block">Seguimiento de Acuse Rechazado</span>
							<span class="d-block">Neto</span>
							<span class="d-block">Iva</span>
							<span class="d-block">Exento</span>
							<span class="d-block">Total</span>
						</div>
						<div class="col-6">
							<span class="d-block text-right"> {{ dteToShow.fechaEmision | date : "dd/MM/yyyy" }}</span>
							<span *ngIf="dteToShow.fechaRecepcionSii == null" class="d-block text-right"> Fecha No disponible</span>
							<span *ngIf="dteToShow.fechaRecepcionSii != null" class="d-block text-right"> {{ dteToShow.fechaRecepcionSii | date : "dd/MM/yyyy" }}</span>

							<span class="d-block text-right"> {{ dteToShow.fechaUltimoProcesamiento | date : "dd/MM/yyyy" }}</span>
							<span *ngIf="dteToShow.fechaVencimientoAcuse != null" class="d-block text-right"> {{ dteToShow.fechaVencimientoAcuse | date : "dd/MM/yyyy" }}</span>
							<span *ngIf="dteToShow.fechaVencimientoAcuse == null" class="d-block text-right"> Fecha No disponible</span>
							<span *ngIf="dteToShow.fechaVencimiento != null" class="d-block text-right"> {{ dteToShow.fechaVencimiento | date : "dd/MM/yyyy" }}</span>
							<span *ngIf="dteToShow.fechaVencimiento == null" class="d-block text-right"> Fecha No disponible</span>
							<span *ngIf="dteToShow.acuseHabilitado" class="d-block text-right"> {{ dteToShow.diasPendientes }}</span>
							<span *ngIf="dteToShow.respuestaEstadoId == null && !dteToShow.acuseHabilitado" class="d-block text-right">Esperando Proceso de Conciliación</span>
							<span *ngIf="dteToShow.respuestaEstadoId == null && dteToShow.acuseHabilitado" class="d-block text-right">Pendiente</span>
							<span *ngIf="dteToShow.respuestaEstadoId == RespuestasEstadoAcuseDte[0].id" class="d-block text-right">Acuse {{ RespuestasEstadoAcuseDte[0].descripcion }}</span>
							<span *ngIf="dteToShow.respuestaEstadoId == RespuestasEstadoAcuseDte[1].id" class="d-block text-right">Acuse Aceptado, {{ RespuestasEstadoAcuseDte[1].descripcion }}</span>
							<span *ngIf="dteToShow.respuestaEstadoId == RespuestasEstadoAcuseDte[2].id" class="d-block text-right">Acuse Aceptado, {{ RespuestasEstadoAcuseDte[2].descripcion }}</span>
							<span *ngIf="dteToShow.respuestaEstadoId == RespuestasEstadoAcuseDte[3].id" class="d-block text-right">Acuse {{ RespuestasEstadoAcuseDte[3].descripcion }}</span>
							<span *ngIf="dteToShow.respuestaEstadoId == RespuestasEstadoAcuseDte[4].id" class="d-block text-right">Acuse {{ RespuestasEstadoAcuseDte[4].descripcion }}</span>
							<span class="d-block text-right"> {{ dteToShow.neto | currency : "$ " : "symbol" : "1.0-0" : "es" }}</span>
							<span class="d-block text-right"> {{ dteToShow.iva | currency : "$ " : "symbol" : "1.0-0" : "es" }}</span>
							<span class="d-block text-right"> {{ dteToShow.exento | currency : "$ " : "symbol" : "1.0-0" : "es" }}</span>
							<span class="d-block text-right"> {{ dteToShow.total | currency : "$ " : "symbol" : "1.0-0" : "es" }}</span>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="modal-footer">
			<button type="button" class="btn btn-success" data-dismiss="modal" (click)="d('Cross click')">Volver</button>
		</div>
	</div>
</ng-template>
<ng-template #datePickerConciliacionModal let-d="dismiss" id="detail-modal">
	<div class="modal-content">
		<form (ngSubmit)="conciliacionRequest(request)" #request="ngForm">
			<div class="modal-header">
				<div class="modal-wizard-label">
					<div class="modal-wizard-title" *ngIf="locale.format == 'MM/YYYY'">Conciliación de documentos recibidos Mensual</div>
					<div class="modal-wizard-title" *ngIf="locale.format == 'DD/MM/YYYY'">Conciliación de documentos recibidos</div>
					<div class="modal-wizard-desc">Indique fecha para lectura de datos en el S.I.I.</div>
				</div>
			</div>
			<div class="modal-body">
				<div class="form-group row mx-auto">
					<div class="col-4 label-control pt-3">Fecha Recepción</div>
					<div class="col-8">
						<input type="text" name="dateConciliacion" [minDate]="minDate" [maxDate]="todayString" ngxDaterangepickerMd [locale]="locale" (change)="detectChangeDate($event)" (input)="detectChangeDate($event)" [(ngModel)]="dateConciliacion" class="form-control" [singleDatePicker]="true" [autoApply]="true" [autocomplete]="false" [showDropdowns]="true" />
						<div *ngIf="request.submitted && (dateConciliacion.startDate == null || dateConciliacion == '' || !validDate)" class="invalid-feedback-group">
							<div *ngIf="dateConciliacion.startDate == null">Campo requerido</div>
							<div *ngIf="!validDate && locale.format == 'MM/YYYY'">Fecha inválida, use el formato mm/yyyy</div>
							<div *ngIf="!validDate && locale.format == 'DD/MM/YYYY'">Fecha inválida, use el formato dd/mm/yyyy</div>
						</div>
					</div>
				</div>
			</div>
			<div class="modal-footer">
				<div class="form-group position-relative has-icon-left mb-0">
					<button type="submit" id="add-contact-item" class="btn btn-success add-contact-item">
						<i class="la la-paper-plane-o d-lg-none"></i>
						<span class="d-none d-lg-block">Enviar</span>
					</button>
					<button type="button" class="btn btn-secondary ml-3" (click)="d('Cross click')">
						<span class="d-none d-lg-block">Cerrar</span>
					</button>
				</div>
			</div>
		</form>
	</div>
</ng-template>

<ng-template #acuseMasivo let-d="dismiss">
	<div class="modal-lg">
		<div class="modal-header">
			<div class="modal-wizard-label">
				<div class="modal-wizard-title">Acuse Masivo de Documentos</div>
				<div class="modal-wizard-desc">Indique respuesta para documento seleccionado</div>
			</div>
		</div>
		<div class="modal-body">
			<app-acuse-recibo-multiple [itemsReception]="selected" [acceptMode]="acuseModoAceptar" (sendCloseRequestEmitter)="closeAcuseMasivoModal()" (sendMassiveRequestEmitter)="requestAcuseMasivo($event)"></app-acuse-recibo-multiple>
		</div>
	</div>
</ng-template>

<ng-template #selectedDteList>
	<ul *ngFor="let dte of selected; let i = index">
		<li *ngIf="i <= 10">{{ dte.folio }} - {{ dte.folio }}</li>
		<li *ngIf="selected.length > 10">...</li>
	</ul>
</ng-template>
